import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import { API_BASE_URL, UPDATE_BRAND } from '../../../Config';

const EditBrand = ({ brandObj }) => {
    const [userDataSession, setUserDataSession] = useState({});
    const [formData, setFormData] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const fileInputRef = useRef(null);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        if (brandObj) {
            setFormData({
                Id: brandObj.Id,
                OrgId: userDataSession.OrgId,
                UpdatedBy: userDataSession.UserId,
                Name: brandObj.Name,
                Code: brandObj.Code,
                Description: brandObj.Description === 'NULL' ? "" : brandObj.Description,
                IsDefault: 1,
                IsActive: 1,
                Filepath: brandObj.Filepath,
            });
            setSelectedImage(brandObj.Filepath);
        }
    }, [brandObj, userDataSession]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                alert('Please select an image file.');
                return;
            }
            if (file.size > 5 * 1024 * 1024) { // 5 MB limit
                alert('File size exceeds 5 MB.');
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
                setSelectedFile(file);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemove = () => {
        setSelectedImage(null);
        setSelectedFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        const formPayload = new FormData();
        formPayload.append('Id', formData.Id);
        formPayload.append('OrgId', formData.OrgId);
        formPayload.append('UpdatedBy', userDataSession.UserId);
        formPayload.append('Name', formData.Name);
        formPayload.append('Code', formData.Code);
        formPayload.append('Description', formData.Description === "" ? "NULL" : formData.Description);
        formPayload.append('IsDefault', formData.IsDefault);
        formPayload.append('IsActive', formData.IsActive);

        if (selectedFile) {
            formPayload.append('file', selectedFile);
        }
        console.log(formData, 'dddddddddddddddddd');

        fetch(`${API_BASE_URL}${UPDATE_BRAND}`, {
            method: 'POST',
            body: formPayload,
        })
            .then(response => response.json())
            .then(data => {
                console.log(data, 'aaaaaaaaaaaaaaaaaaaaaa')
                setSubmitBtnLoading(false);
                if (data.ResultData[0]['Status'] === 'Success') {
                    Swal.fire({
                        title: `Brand edited Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error('Error updating brand:', error);
            });
    };

    return (
        <div>
            {/* Edit Brand */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightBrandEdit"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Edit Brand</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="content">
                            <div className="">
                                <div className="mb-3">
                                    <label className="form-label">Brand</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Name"
                                        value={formData.Name || ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Code"
                                        value={formData.Code || ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control"
                                        name="Description"
                                        value={formData.Description || ''}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </div>

                                <div className="profile-pic-upload mb-3">
                                    <div className="profile-pic brand-pic">
                                        {/* <span>
                                            <img src={`https://pcuploadfiles.azurewebsites.net/download?path=${selectedImage}`} alt="Brand"/>
                                        </span> */}
                                            <img
    src={selectedImage ? `https://pcuploadfiles.azurewebsites.net/download?path=${selectedImage}` : "assets/img/brand/brand-icon-02.png"}
    alt="Brand"
    style={{ width: '3.6rem' }}
/>
                                        {selectedImage && (
                                            <a href="javascript:void(0);" className="remove-photo" onClick={handleRemove}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x x-square-add">
                                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                                </svg>
                                            </a>
                                        )}
                                    </div>
                                    <div className="image-upload mb-0">
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                        />
                                        <div className="image-uploads">
                                            <h4>Change Image</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer-btn">
                                    <button
                                        type="button"
                                        className="btn btn-cancel me-2"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                         disabled={submitBtnLoading}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='submit'
                                        className="btn btn-submit"
                                         disabled={submitBtnLoading}
                                    >
                                        {submitBtnLoading ? 'Submitting..' : 'Save Changes'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

EditBrand.propTypes = {
    brandObj: PropTypes.object.isRequired,
};

export default EditBrand;
